export default "__VITE_ASSET__Bqdd5Kge__"